import { api } from "./api";

export const uploadFileApi = (params) => {
    return api.post(`/translator/upload-doc`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const translateDocApi = (params) => {
    return api.post(`/translator/translate-doc`, JSON.stringify(params));
};

export const batchTranslateDocApi = (params) => {
    return api.post(`/translator/batch-translate`, JSON.stringify(params));
};

export const batchTranslateViewDocApi = (params) => {
    return api.post(`/translator/view-batch-document`, JSON.stringify(params));
};

export const viewDocApi = (params) => {
    return api.post(`/translator/view-document`, JSON.stringify(params));
};

export const glossaryDropDownApi = (params) => {
    return api.get(`/translator/glossary-list`, { params: params });
};

export const recentTranslationsApi = (params) => {
    return api.get(`/translator/recent-translations`, { params: params });
};

export const recentViewApi = (params) => {
    return api.get(`/translator/recent-view`, { params: params });
};

export const batchTranslateMoreThan20DocApi = (params) => {
    return api.post(`/translator/more-translate-batch`, JSON.stringify(params));
};


export const getSignedUrlAPi = (params) => {
    return api.post(`/translator/get-url`, JSON.stringify(params));
};

export const htmlFileTranslateApi = (params) => {
    return api.post(`/translator/translate-html`, JSON.stringify(params));
};